import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e53cb1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-hpl" }
const _hoisted_2 = { class: "nge-hpl-label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Places, x y z as the coordinate bar shows them", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "nge-hpl-muted"
}
const _hoisted_5 = { class: "nge-hpl-list" }
const _hoisted_6 = ["onClick", "onKeydown"]
const _hoisted_7 = { class: "nge-hpl-body" }
const _hoisted_8 = { class: "nge-hpl-xyz" }
const _hoisted_9 = {
  key: 0,
  class: "nge-hpl-sub"
}
const _hoisted_10 = {
  key: 1,
  class: "nge-hpl-sub"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 3,
  class: "nge-hpl-warn"
}
const _hoisted_13 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString($setup.cuts) + " cut, " + _toDisplayString($setup.rows.length - $setup.cuts) + " extend", 1 /* TEXT */)
    ]),
    (!$setup.rows.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No places on screen yet."))
      : _createCommentVNode("v-if", true),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (r) => {
        return (_openBlock(), _createElementBlock("li", {
          key: r.id,
          class: _normalizeClass(["nge-hpl-place", { 'nge-hpl-place--on': r.id === $setup.fromEdits.selected }]),
          tabindex: "0",
          title: "Go there",
          onClick: $event => ($setup.go(r)),
          onKeydown: _withKeys($event => ($setup.go(r)), ["enter"])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["nge-hpl-dot", `nge-hpl-dot--${r.kind}`])
          }, _toDisplayString(r.n ?? '+'), 3 /* TEXT, CLASS */),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(r.at.join(', ')), 1 /* TEXT */),
            (r.place)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(r.kind === 'cut' ? 'Cut' : 'Joined') + " " + _toDisplayString($setup.day(r.place.at)), 1 /* TEXT */),
                  (r.place.user)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" by " + _toDisplayString(r.place.user), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "Added by you")),
            (r.ids.length > 1)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "nge-hpl-sub",
                  title: `A gem anywhere on the piece cut off finds this merger (${r.ids.length} points along it)`
                }, "Anywhere on the piece cut off (" + _toDisplayString(r.ids.length) + " points)", 9 /* TEXT, PROPS */, _hoisted_11))
              : _createCommentVNode("v-if", true),
            (r.place?.wide)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "The cut's points were far apart: check where the merger is."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "nge-hpl-x",
            "aria-label": "Take this place out",
            title: "Take this place out",
            onClick: _withModifiers($event => ($setup.drop(r)), ["stop"])
          }, "×", 8 /* PROPS */, _hoisted_13)
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_6))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}